window.addEventListener('DOMContentLoaded', function() {
  /* Mega Menu */
  const megaMenuItems = document.querySelectorAll('.mega-menu__collection--item[data-id]');

  for(const megaMenuItem of megaMenuItems) {
    megaMenuItem.addEventListener('mouseover', function() {
      document.querySelector('.mega-menu__collection--product-container.active').classList.remove('active');
      activeItem = document.querySelector(`.mega-menu__collection--product-container[data-id="${megaMenuItem.dataset.id}"]`);
      if(activeItem) {
        activeItem.classList.add('active');
      }
    });
  }
});